module.exports = __webpack_public_path__ + "static/img/sequence-boterham.be1bd28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/sequence-boterham.png
// module id = 673
// module chunks = 64